import { ImpactModule } from 'types'
import { ACTIVITIES_PAGES } from './pages'
import { ACTIVITIES_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const ACTIVITIES_MODULE: ImpactModule = {
  NAME: 'activity',
  NAME_PTBR: 'Atividades',
  UPPER_NAME: 'ACTIVITY',
  API_NAME: 'ACTIVITY',
  PAGES: ACTIVITIES_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: ACTIVITIES_PAGES_ORDER_FOR_PERMISSIONS,
}
